import React, { Component } from "react";
import {
  Box,
  Alert,
  Button,
  Popover,
  MenuList,
  MenuItem,
  IconButton,
  ListItemText,
} from "@mui/material";
import {
  Filter,
  Table,
  DialogExhibitions,
  ComplexDrawer,
} from "./components";
import {
  VisibleContent
} from "../../components";
import agent from "../../agent/agent";
import {RouterContext} from "../../layouts/CabinetLayout";
import {showError, showSuccess, showWarning} from "../../utils/notifications";
import {refreshContracts, setContract} from "../../store/ContractsStore";
import {changeCount} from "../../store/NotificationsStore";
import {connect} from "react-redux";
import PopupState, {bindTrigger, bindPopover} from "material-ui-popup-state";
import { resolveComplexDrawerFromSearch } from "../../utils/sectionNavigation";

const initFilter = {
  class: [],
  complex_serial: "",
  model: "",
  location: "",
  sort_field: "",
  sort_direction: "asc",
  page: 1,
  limit: 25
};

class Complex extends Component {
  static contextType = RouterContext;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filter: {...initFilter},
      errorMessage: "",
      totalPages: 1,
      totalCount: 0,
      totalCountAll: 0,
      isLoading: true,
      contractId: null,

      drawerOpen: false,
      drawerItem: null,
      drawerState: { activeTab: null, selectedCamera: null },
    };
    this.exhibitionsDialogRef = React.createRef();
  }

  componentDidMount = async () => {
    await this.initState();
  }
  componentDidUpdate = async (prevProps) => {
    const prevId = prevProps.contract?.available_contracts?.contract_id;
    const currentId = this.props.contract?.available_contracts?.contract_id;
    if (prevId !== currentId) {
      await this.setState({isLoading: true})
      await this.initState();
    }
  }
  initState = async () => {
    const contractId = this.props?.contract?.available_contracts?.contract_id;
    await this.setState({contractId: contractId});
    await this.getTotalCountAll(contractId);
    await this.initFilter();
  }

  getTotalCountAll = async (contractId) => {
    const id = contractId || this.state.contractId;
    if (!id) return;
    const res = await agent.get(`/operator/sensors?contract_id=${id}&limit=1&page=1`)
      .then((res) => res)
      .catch(() => null);
    const count = Number.parseFloat(res?.headers?.['x-pagination-total-count'] || '0');
    await this.setState({ totalCountAll: count });
  }

  getItems = async () => {
    await this.setState({ isLoading: true, errorMessage: "" });
    const filter = this.getFilter();
    const res = await agent.get(`/operator/sensors?${ filter }`).then((res) => res).catch((err) => {
      return { error: err?.response }
    });
    if (res?.error) {
      const _message = res?.error?.data?.details || '';
      await this.setState({ isLoading: false, errorMessage: _message });
      return
    }
    const totalCount = Number.parseFloat(res?.headers?.['x-pagination-total-count'] || '0');
    const totalPages = Math.ceil(totalCount / (this.state.filter?.limit || 20));

    const items = res?.data?.data || [];
    const nextState = {
      isLoading: false,
      totalPages,
      totalCount,
      items,
    };
    const search = new URLSearchParams(window.location.search);
    const shouldOpenFromUrl = search.get("open") === "1";
    let openedFromUrl = false;

    if (shouldOpenFromUrl) {
      const resolved = await resolveComplexDrawerFromSearch(this.state.contractId, search);
      if (resolved) {
        openedFromUrl = true;
        nextState.drawerOpen = true;
        nextState.drawerItem = resolved.drawerItem;
        nextState.drawerState = resolved.drawerState;
      } else if (search.get("target_id")) {
        const serial = String(search.get("focus_serial") || search.get("complex_serial") || "").trim();
        showWarning(
          "Комплекс не найден",
          serial
            ? `По текущему заданию комплекс «${serial}» в справочнике не найден`
            : "По текущему заданию комплекс в справочнике не найден",
        );
      }
    }
    if (!openedFromUrl) {
      const serialQuery = String(this.state.filter?.complex_serial || "").trim().toLowerCase();
      const shouldOpenDrawer = serialQuery && (shouldOpenFromUrl || items.length === 1);
      if (shouldOpenDrawer) {
        const match =
          items.find((item) => String(item.complex_serial || "").toLowerCase() === serialQuery) ||
          items[0];
        if (match) {
          nextState.drawerOpen = true;
          nextState.drawerItem = match;
          nextState.drawerState = { activeTab: null, selectedCamera: null };
        }
      }
    }
    await this.setState(nextState);
    this.updateUrlSearch();
  }

  getFilter = () => {
    let filterSrt = [`contract_id=${this.state.contractId}`];
    const filter = this.state.filter;
    Object.keys(filter).forEach((key) => {
      let _value = filter[key];
      if (key === 'class') {
        if (Array.isArray(_value) && _value.length > 0) {
          _value.forEach((v) => { if (v) filterSrt.push(`class=${encodeURIComponent(v)}`); });
        }
        return;
      }
      if (!!_value && _value !== '') {
        filterSrt.push(`${key}=${_value}`);
      }
    })
    return filterSrt.filter((t) => !!t).join('&')
  }
  initFilter = async () => {
    const search = new URLSearchParams(window.location.search);
    const parsedFilter = { ...initFilter };
    const classFromUrl = search.getAll('class');
    if (classFromUrl.length > 0) parsedFilter.class = classFromUrl;
    for (const [key, value] of search.entries()) {
      if (key === 'class') continue;
      if (key in initFilter) {
        if (['complex_serial', 'model', 'location', 'sort_field', 'sort_direction'].includes(key)) {
          parsedFilter[key] = value;
        } else if (['page', 'limit'].includes(key)) {
          const numValue = parseInt(value, 10);
          if (!isNaN(numValue)) parsedFilter[key] = numValue;
        }
      }
    }
    await this.setState({ filter: parsedFilter }, async () => { await this.getItems(); });
  }
  resetFilter = async () => {
    await this.setState({ filter: {...initFilter} });
    await this.getItems();
  }
  changeFilter = async (filter, isFastState = false) => {
    await this.setState({ filter });
    if (!isFastState) return
    await this.getItems();
  }
  updateUrlSearch = () => {
    const { filter } = this.state;
    const searchParams = new URLSearchParams();
    Object.keys(filter).forEach((key) => {
      const value = filter[key];
      const defaultValue = initFilter[key];
      if (key === 'class') {
        const selected = Array.isArray(value) ? value : [];
        const def = Array.isArray(defaultValue) ? defaultValue : [];
        if (selected.length === def.length && selected.every((v, i) => v === def[i])) return;
        selected.forEach((v) => { if (v) searchParams.append('class', v); });
        return;
      }
      if (value === defaultValue) return;
      if (value !== null && value !== undefined && value !== '') {
        searchParams.set(key, value.toString());
      }
    });
    const newSearch = searchParams.toString();
    const newUrl = newSearch ? `${this.context.location.pathname}?${newSearch}` : this.context.location.pathname;
    this.context.navigate(newUrl, { replace: true });
  }

  export = async (encoding) => {
    const {contractId, filter} = this.state;
    const body = {
      type: "sensors",
      contract_id: contractId,
      client_type: "web_admin",
      encoding: Number.parseFloat(encoding),
    };
    if (Array.isArray(filter.class) && filter.class.length > 0) body.class = filter.class;
    if (filter.complex_serial) body.complex_serial = filter.complex_serial;
    if (filter.model) body.model = filter.model;
    if (filter.location) body.location = filter.location;

    const res = await agent.post('/export/jobs', body)
      .then((res) => res.data).catch((err) => ({ error: err?.response?.data }));
    if (res?.error) {
      showError('Ошибка экспорта', res?.error?.details);
      return;
    }
    showSuccess('Экспорт комплексов', 'Отчет поставлен в очередь, вы можете его найти в разделе "Результаты экспорта"', {paddingTop: '45px'});
    const currentExportCount = this.props.notifications?.counts?.export || 0;
    this.props.changeCount({ key: 'export', value: currentExportCount + 1 });
  }

  handleOpenDrawer = (item) => {
    this.setState({
      drawerOpen: true,
      drawerItem: item,
      drawerState: { activeTab: null, selectedCamera: null },
    });
  }
  handleCloseDrawer = () => {
    this.setState({
      drawerOpen: false,
      drawerItem: null,
      drawerState: { activeTab: null, selectedCamera: null },
    });
  }

  render() {
    const {
      items, filter, isLoading, totalPages, totalCount, totalCountAll, contractId, errorMessage,
      drawerOpen, drawerItem, drawerState,
    } = this.state;
    const isError = Boolean(errorMessage);

    const handleExport = (type, popupState) => {
      popupState.close();
      this.export(type);
    };

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Хэдер */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 500, lineHeight: "28px", color: "#111111" }}>Комплексы</h1>
            {totalCountAll > 0 && (
              <span style={{
                fontSize: 12, fontWeight: 500, lineHeight: "18px",
                color: "#432DD7", backgroundColor: "#E0E7FF",
                borderRadius: 16, padding: "2px 8px",
              }}>
                {totalCountAll.toLocaleString('ru-RU')}
              </span>
            )}
            <IconButton onClick={this.getItems} size="small" sx={{ color: "#4F39F6" }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 3.125 13.5 3.125 13.5M3.125 13.5H6.25M3.125 13.5V17M2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.8438 2.5 17.5 6.5 17.5 6.5M17.5 6.5V3M17.5 6.5H14.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </IconButton>
          </Box>
          <PopupState variant="popover">
            {(popupState) => (
              <div>
                <Button
                  variant="outlined"
                  disabled={isError}
                  startIcon={
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.925 10.3418L10.8333 11.3835V6.66683C10.8333 6.44582 10.7455 6.23385 10.5893 6.07757C10.433 5.92129 10.221 5.8335 10 5.8335C9.77899 5.8335 9.56703 5.92129 9.41075 6.07757C9.25447 6.23385 9.16667 6.44582 9.16667 6.66683V11.3252L8.09167 10.2418C7.93475 10.0849 7.72192 9.99675 7.5 9.99675C7.27808 9.99675 7.06525 10.0849 6.90833 10.2418C6.75141 10.3987 6.66326 10.6116 6.66326 10.8335C6.66326 11.0554 6.75141 11.2682 6.90833 11.4252L9.40833 13.9252C9.48759 14.001 9.58104 14.0605 9.68333 14.1002C9.78309 14.1443 9.89094 14.167 10 14.167C10.109 14.167 10.2169 14.1443 10.3167 14.1002C10.3657 14.0804 10.4108 14.0522 10.45 14.0168C10.4964 13.997 10.5388 13.9688 10.575 13.9335L13.075 11.5502C13.2352 11.3977 13.3283 11.1878 13.3338 10.9666C13.3392 10.7455 13.2566 10.5312 13.1041 10.371C12.9516 10.2108 12.7417 10.1177 12.5206 10.1122C12.2995 10.1067 12.0852 10.1893 11.925 10.3418Z" fill="currentColor"/>
                      <path d="M10 1.6665C8.35183 1.6665 6.74066 2.15525 5.37025 3.07092C3.99984 3.9866 2.93174 5.28809 2.30101 6.81081C1.67028 8.33353 1.50525 10.0091 1.8268 11.6256C2.14834 13.2421 2.94201 14.727 4.10745 15.8924C5.27289 17.0578 6.75774 17.8515 8.37425 18.173C9.99076 18.4946 11.6663 18.3296 13.189 17.6988C14.7118 17.0681 16.0132 16 16.9289 14.6296C17.8446 13.2592 18.3333 11.648 18.3333 9.99984C18.3333 8.90549 18.1178 7.82186 17.699 6.81081C17.2802 5.79976 16.6664 4.8811 15.8926 4.10728C15.1188 3.33346 14.2001 2.71963 13.189 2.30084C12.178 1.88205 11.0944 1.6665 10 1.6665ZM10 16.6665C8.68146 16.6665 7.39253 16.2755 6.2962 15.543C5.19988 14.8104 4.34539 13.7692 3.84081 12.5511C3.33622 11.3329 3.2042 9.99244 3.46144 8.69924C3.71867 7.40603 4.35361 6.21814 5.28596 5.28579C6.21831 4.35344 7.4062 3.7185 8.69941 3.46127C9.99261 3.20403 11.333 3.33606 12.5512 3.84064C13.7694 4.34522 14.8106 5.19971 15.5431 6.29604C16.2757 7.39236 16.6667 8.6813 16.6667 9.99984C16.6667 11.7679 15.9643 13.4636 14.714 14.7139C13.4638 15.9641 11.7681 16.6665 10 16.6665Z" fill="currentColor"/>
                    </svg>
                  }
                  sx={{
                    borderColor: "#E4E4E7", color: "#27272A", fontSize: 14, fontWeight: 500,
                    height: 44, borderRadius: "4px", textTransform: "none",
                    "&:hover": { borderColor: "#4F39F6", color: "#4F39F6", backgroundColor: "transparent" },
                  }}
                  {...bindTrigger(popupState)}
                >Экспорт в XLSX</Button>
                <Popover
                  {...bindPopover(popupState)}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                  transformOrigin={{vertical: 'top', horizontal: 'right'}}
                  disableScrollLock
                  slotProps={{ backdrop: { sx: { backgroundColor: "transparent" } } }}
                >
                  <MenuList>
                    <MenuItem onClick={handleExport.bind(this, '0', popupState)}>
                      <ListItemText>UTF-8 (По умолчанию)</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={handleExport.bind(this, '10', popupState)}>
                      <ListItemText>Windows-1251</ListItemText>
                    </MenuItem>
                  </MenuList>
                </Popover>
              </div>
            )}
          </PopupState>
        </Box>

        {/* Фильтры */}
        <Filter
          filter={filter}
          onSearch={this.getItems}
          onReset={this.resetFilter}
          onChange={this.changeFilter}
        />

        {/* Таблица */}
        <VisibleContent visible={!isError}>
          <Table
            items={items}
            filter={filter}
            isLoading={isLoading}
            totalPages={totalPages}
            totalCount={totalCount}
            onSearch={this.getItems}
            onChangeFilter={this.changeFilter}
            drawerOpen={drawerOpen}
            onRowClick={this.handleOpenDrawer}
          />
        </VisibleContent>
        <VisibleContent visible={isError}>
          <Alert variant="filled" color="error">{errorMessage}</Alert>
        </VisibleContent>

        {/* Боковая панель */}
        <ComplexDrawer
          open={drawerOpen}
          item={drawerItem}
          onClose={this.handleCloseDrawer}
          initialTab={drawerState?.activeTab}
          initialSelectedCamera={drawerState?.selectedCamera}
          exhibitionsDialogRef={this.exhibitionsDialogRef}
        />

        <DialogExhibitions ref={this.exhibitionsDialogRef} contractId={contractId}/>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  contract: state.contracts?.contract || null,
  notifications: state.notifications || null,
});
const mapDispatchToProps = { setContract, refreshContracts, changeCount };

export default connect(mapStateToProps, mapDispatchToProps)(Complex)
